import React from 'react';
import { Link } from 'react-router-dom';
import { FiHeart, FiTrash2, FiShoppingCart, FiArrowRight, FiX } from 'react-icons/fi';
import { useShopping } from '../context/ShoppingContext';
import '../styles/Wishlist.css';
import '../styles/Cart.css';

const Wishlist = () => {
  const { wishlistItems, addToWishlist, addToCart } = useShopping();

  const handleAddToCart = (product) => {
    addToCart(product);
    addToWishlist(product); // Remove from wishlist after adding to cart
  };

  return (
    <div className="wishlist-page">
      <div className="wishlist-container">
        {wishlistItems.length === 0 ? (
          <div className="empty-cart">
            <div className="empty-cart-image" style={{ marginBottom: '20px' }}>
              <FiHeart size={100} color="#ff3f6c" />
            </div>
            <h2>Your wishlist is empty</h2>
            <p>Add products you love to your wishlist</p>
            <Link to="/products" className="add-from-wishlist-btn">
              START SHOPPING
            </Link>
          </div>
        ) : (
          <div className="wishlist-content">
            <h1>My Wishlist</h1>
            <p className="wishlist-count">You have {wishlistItems.length} items in your wishlist</p>

            <div className="wishlist-grid">
              {wishlistItems.map((product) => (
                <div key={product.id} className="wishlist-item">
                  <Link to={`/product/${product.id}`} className="item-image-link">
                    <img src={product.images && product.images.length > 0 ? product.images[0] : product.image} alt={product.name} className="item-image" />
                    {product.discount && (
                      <span className="discount-badge">{product.discount}% OFF</span>
                    )}
                  </Link>

                  <button
                    className="wishlist-remove-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      addToWishlist(product);
                    }}
                    title="Remove from wishlist"
                  >
                    <FiX />
                  </button>

                  <div className="item-info">
                    <Link to={`/product/${product.id}`} className="item-name-link">
                      <h3>{product.name}</h3>
                    </Link>
                    <p className="seller">By {product.seller}</p>

                    <div className="item-price">
                      <span className="current-price">
                        ₹{product.price.toLocaleString('en-IN')}
                      </span>
                      {product.originalPrice && (
                        <span className="original-price">
                          ₹{product.originalPrice.toLocaleString('en-IN')}
                        </span>
                      )}
                    </div>

                    <div className="item-actions">
                      <button
                        className="add-to-cart-btn"
                        onClick={() => handleAddToCart(product)}
                      >
                        <FiShoppingCart /> Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
